import request from '../../../helpers/request';

const deleteMeter = async (id) => {
  return await request.delete(
    `/RentPlace/meter/${id}`,
    {},
    'При удалении счетчика произошла ошибка'
  );
};

export default deleteMeter;
